import PropTypes from "prop-types";
import React from "react";

class UserGroupToggle extends React.Component {
  state = {
    username: "",
    groupname: "",
    visible: "group"
  };

  handleChange = event => {
    const { name, value } = event.target;
    const { onUpdate, isValid } = this.props;
    // Allow alphanumeric and additionally an @domain suffix
    const pattern = RegExp("^[a-zA-Z][a-zA-Z0-9-_@.]{0,}$");

    let newState;
    if (name === "username") {
      newState = { username: value, groupname: "" };
    } else if (name === "groupname") {
      newState = { username: "", groupname: value };
    }

    this.setState(newState, () => {
      onUpdate(newState);
      if (isValid) {
        isValid(pattern.test(value));
      }
    });
  };

  handleChangeVisiblity = e => {
    const { currentToggle } = this.props;
    this.setState({ visible: e.target.value });
    currentToggle(e.target.value);
  };

  render() {
    const { visible, username, groupname } = this.state;
    const { heading, tooltip } = this.props;
    return (
      <div>
        <div className="u-sv1">
          {heading && (
            <div className="u-sv1">
              <span>{heading}</span>
              {tooltip && (
                <span className="p-tooltip p-tooltip--top-center">
                  <i className="p-icon--information p-icon__text" />
                  <span className="p-tooltip__message">{tooltip}</span>
                </span>
              )}
            </div>
          )}
          <input
            className="p-radio"
            id="group"
            type="radio"
            value="group"
            onChange={this.handleChangeVisiblity}
            checked={visible === "group"}
          />
          <label htmlFor="group">Group</label>

          <input
            className="p-radio"
            id="user"
            type="radio"
            value="user"
            onChange={this.handleChangeVisiblity}
            checked={visible === "user"}
          />
          <label htmlFor="user">User</label>
        </div>
        {visible === "user" && (
          <div className="p-form__group">
            <div className="p-form__control">
              <input
                id="username"
                name="username"
                type="text"
                placeholder="username"
                value={username}
                onChange={this.handleChange}
              />
            </div>
          </div>
        )}
        {visible === "group" && (
          <div className="p-form__group">
            <div className="p-form__control">
              <input
                id="groupname"
                name="groupname"
                type="text"
                placeholder="group name"
                value={groupname}
                onChange={this.handleChange}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

UserGroupToggle.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  isValid: PropTypes.func,
  currentToggle: PropTypes.func,
  heading: PropTypes.string,
  tooltip: PropTypes.string
};

UserGroupToggle.defaultProps = {
  heading: "Select a group or user.",
  isValid: () => true,
  currentToggle: () => "group",
  tooltip: undefined
};

export default UserGroupToggle;
